(() => {
  // Guard against duplicate script loads, including theme editor reloads.
  if (window.dooboAmazonClickTrackingInitialized) return;
  window.dooboAmazonClickTrackingInitialized = true;

  // Brand Store campaigns shared by the home banner and product buttons.
  // Other campaigns keep the existing product-metafield/default destination.
  const brandCampaignTags = new Map([
    ['test_utm', '74B8F24C4F295241E7DA0DB906C30844'],
    ['dontgiveup', 'EBB60BD0827B2332EE3E539E3C52885F'],
    ['elevate_your_meal', '1B15AA90D1A8B55992EF809E2868B7E8'],
    ['nutritious', 'AD2BEA094838EE2C95730B524E8EB3D3'],
    ['rice_can_do_better', 'ED582E9E00040812D9594706249E8855'],
    ['review1', '4BE78046FF82987B0F74513349A7052E'],
    ['review2', '0E80D78DDBC2135171CA608F397B98FB'],
    ['swaadista', 'B3623EAC6360C999BF27274F67D22DA3'],
    ['rebelplantivore', '798FBC477DFF6C839A562CC73FD2C72A'],
    ['soukaina', '2C29242E9C9D6D6B47212C120AF1A373'],
    ['amber', '1510BA4043F2D8B7815275DD1ACD9760'],
    ['erish', '49B01CB98D7679A11AEA577807D46A3C'],
    ['peterpansauce', '85E20CC1691A8080FB00B4351E6C674D'],
  ]);

  const incomingCampaign = new URLSearchParams(window.location.search)
    .get('utm_campaign')?.toLowerCase();
  let campaign = incomingCampaign;
  try {
    if (incomingCampaign) {
      sessionStorage.setItem('doobo_utm_campaign', incomingCampaign);
    } else {
      campaign = sessionStorage.getItem('doobo_utm_campaign');
    }
  } catch {
    // Direct campaign links still work when browser storage is unavailable.
  }

  const tag = brandCampaignTags.get(campaign);
  const brandUrl = tag
    ? `https://www.amazon.com/stores/DooboFoods/page/3A41CB8F-9EB2-49FC-B7D4-A78608F844CC?maas=maas_adg_${tag}_afap_abs&ref_=aa_maas&tag=maas`
    : '';

  const updateLink = (link) => {
    if (!brandUrl) return;
    link.href = brandUrl;
    link.dataset.amazonCampaign = campaign;
  };
  const updateLinks = () => {
    document.querySelectorAll('a[data-amazon-track]').forEach(updateLink);
  };
  updateLinks();
  document.addEventListener('shopify:section:load', updateLinks);
  // Cover buttons inserted by section rendering before following their links.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-amazon-track]');
    if (link) updateLink(link);
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-amazon-track]');
    if (!link) return;

    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') return;

    // Tracking must never interrupt the existing Amazon navigation.
    try {
      const result = analytics.publish('amazon_outbound_click', {
        button_location: link.dataset.buttonLocation || '',
        product_id: link.dataset.productId || '',
        product_handle: link.dataset.productHandle || '',
      });
      Promise.resolve(result).catch(() => {});
    } catch {
      // The link still works when analytics is unavailable.
    }
  });
})();
